"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconMicOff = function IconMicOff(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconMicOff', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    d: "M.683.197c.244-.26.64-.26.884 0l8.192 8.738.008.008a.662.662 0 0 1 .007.007l1.665 1.774a.632.632 0 0 1 .228.245l3.65 3.893a.698.698 0 0 1 0 .943.598.598 0 0 1-.884 0l-3.348-3.573a4.838 4.838 0 0 1-2.46 1.094v1.34H10.5c.314 0 .574.247.618.569l.007.098c0 .369-.28.667-.625.667l-2.488-.001L8 16H5.5c-.345 0-.625-.298-.625-.667 0-.368.28-.666.625-.666l1.875-.001v-1.34a4.735 4.735 0 0 1-1.071-.275l-.21-.086C4.208 12.135 2.984 10.17 3 8V6.667c0-.368.28-.666.625-.666s.625.298.625.666v1.339c-.011 1.63.907 3.104 2.32 3.726.405.178.827.276 1.249.298a.589.589 0 0 1 .363-.001 3.596 3.596 0 0 0 2.01-.749l-.923-.984a2.363 2.363 0 0 1-2.225.167C6.11 10.05 5.5 9.079 5.5 8V6.277L.683 1.139A.7.7 0 0 1 .611.29zM12.375 6c.345 0 .625.298.625.666v1.334c0 .314-.027.628-.079.937-.06.363-.385.604-.725.539-.34-.065-.566-.412-.505-.774.04-.232.059-.467.059-.702V6.667c0-.368.28-.666.625-.666zM6.749 7.609L6.75 8c0 .539.305 1.025.772 1.23.26.115.54.131.801.057L6.749 7.609zM5.55 2.135C5.806.793 6.973-.125 8.251.013 9.53.15 10.501 1.299 10.5 2.668v3.56c0 .368-.28.666-.625.666s-.625-.298-.625-.667v-3.56c0-.685-.485-1.259-1.124-1.328-.64-.069-1.223.39-1.351 1.061-.069.361-.399.594-.737.521-.338-.073-.557-.425-.488-.786z"
  }));
};

var _default = IconMicOff;
exports.default = _default;